import React, { useState } from "react";

import Authenticated from "./Authenticated";
import UnAuthenticated from "./unAuthenticated";

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("Token"));

  return token ? <Authenticated /> : <UnAuthenticated setToken={setToken} />;
};

export default App;
